module.exports = __webpack_public_path__ + "static/media/grand-bnb.cd29ace7.png";